if (!customElements.get('product-recommendations')) {
  customElements.define(
    'product-recommendations',
    class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        if (this.dataset.initialized === 'true') return;
        this.dataset.initialized = 'true';

        if (this.dataset.recommendationsPerformed === 'true' || !this.dataset.url) return;

        if (!('IntersectionObserver' in window)) {
          this.loadRecommendations();
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.loadRecommendations();
          },
          { rootMargin: '0px 0px 200px 0px' }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }

      async loadRecommendations() {
        if (this.dataset.loading === 'true') return;
        this.dataset.loading = 'true';

        try {
          const response = await fetch(this.dataset.url, {
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) throw new Error(`HTTP ${response.status}`);

          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const nextRecommendations = html.querySelector(
            `product-recommendations[data-section-id="${CSS.escape(this.dataset.sectionId)}"]`
          );
          const nextContent = nextRecommendations?.querySelector('[data-product-recommendations-content]');

          if (nextContent) {
            this.innerHTML = nextRecommendations.innerHTML;
            this.dataset.recommendationsPerformed = 'true';
          } else if (!this.querySelector('[data-product-recommendations-content]')) {
            this.remove();
          }
        } catch (error) {
          if (!this.querySelector('[data-product-recommendations-content]')) this.remove();
        } finally {
          delete this.dataset.loading;
        }
      }
    }
  );
}
